<header
  class="bcledger-header d-flex align-items-center justify-content-between has-border py-3 mb-4">
  <h1>Client Deposit Invoice Review</h1>
  <div class="bcledger-panel d-flex justify-content-between ms-2 me-auto">
    <div class="lds-ring inline me-auto ms-2" *ngIf="false">
      <jni-spinner></jni-spinner>
    </div>
  </div>
  <div class="user-panel col-auto d-flex justify-content-between">
    <div class="ms-3 nav-link p-0 dropdown d-flex align-items-center">
      <i class="icon-Export-excel me-2"></i>
      <a class="link" (click)="exportExcelFile()">Export excel</a>
    </div>
  </div>
</header>

<div class="p-wrapper-custom">
  <p-table
    #dt
    responsiveLayout="scroll"
    [value]="ipClientDepositDetailValue"
    styleClass="p-datatable-customers"
    [rowHover]="true"
    [rows]="20"
    [showCurrentPageReport]="true"
    [rowsPerPageOptions]="[10, 20, 50, 1000]"
    [autoLayout]="true"
    [resizableColumns]="true"
    [paginator]="ipClientDepositDetailValue.length >= 20">
    <ng-template pTemplate="caption">
      <div class="d-flex align-items-center">
        <ng-container> </ng-container>
      </div>
    </ng-template>
    <ng-template pTemplate="header">
      <tr>
        <!-- <th>Charges Code</th> -->
        <th style="width: 6rem">Creation Date</th>
        <th style="width: 10rem" pSortableColumn="Amount">
          Amount
          <p-sortIcon field="Amount"></p-sortIcon>
        </th>
        <th pSortableColumn="Txt">
          Description
          <p-sortIcon field="Txt"></p-sortIcon>
        </th>
      </tr>
      <tr>
        <th></th>
        <th>
          <div class="d-flex">
            <input
              jniAutoCompleteBlocker
              pInputText
              type="text"
              name="Amount"
              id="Amount"
              style="max-width: 200px"
              (input)="
                dt.filter($any($event.target).value, 'Amount', 'startsWith')
              "
              placeholder=""
              class="p-column-filter p-inputtext p-component" />
          </div>
        </th>
        <th>
          <div class="d-flex">
            <input
              jniAutoCompleteBlocker
              pInputText
              type="text"
              name="Txt"
              id="Txt"
              style="max-width: 200px"
              (input)="
                dt.filter($any($event.target).value, 'Txt', 'startsWith')
              "
              placeholder=""
              class="p-column-filter p-inputtext p-component" />
          </div>
        </th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-clientDepositList let-rowIndex="rowIndex">
      <tr
        class="p-selectable-row"
        [pSelectableRow]="clientDepositList"
        [pSelectableRowIndex]="rowIndex">
        <td>{{ clientDepositList?.InvoiceDate | date: "yyyy-MM-dd" }}</td>
        <td>{{ clientDepositList?.Amount | currency }}</td>
        <td>{{ clientDepositList?.Txt }}</td>
      </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage">
      <tr>
        <td colspan="30">No Data Found.</td>
      </tr>
    </ng-template>
  </p-table>
</div>
